import React, { useState } from 'react';
import { sendPasswordResetEmail, getAuth } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const ResetPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const auth = getAuth();
  const navigate = useNavigate();

  const handleReset = async () => {
    try {
      await sendPasswordResetEmail(auth, email);
      setStatus('✅ Reset link sent! Check your email.');
    } catch (err) {
      console.error(err);
      setStatus('❌ Error sending reset email.');
    }
  };

  return (
    <div style={styles.container}>
      <h2><span role = "img" aria-label = "lock">🔐 Reset Password</span></h2>
      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={styles.input}
      />
      <button onClick={handleReset} style={styles.button}>Send Reset Link</button>
      {status && <p>{status}</p>}
      <button onClick={() => navigate('/signin')} style={styles.backLink}>Back to Sign In</button>
    </div>
  );
};

const styles = {
  container: {
    padding: '40px',
    maxWidth: '400px',
    margin: 'auto',
    textAlign: 'center',
    fontFamily: 'Georgia, serif'
  },
  input: {
    padding: '10px',
    width: '100%',
    marginBottom: '15px',
    fontSize: '1rem'
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginBottom: '10px'
  },
  backLink: {
    background: 'none',
    color: '#007bff',
    border: 'none',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginTop: '10px'
  }
};

export default ResetPasswordPage;
